import { create } from 'zustand';
import { useShallow } from 'zustand/react/shallow';

import { type StartAppArgs, type TgState } from './types';

const defaultTgState: Omit<TgState, 'actions'> = {
  startAppArgs: {} as StartAppArgs,
  isFullscreen: false,
  initURLHash: '',
  backButton: {
    customAction: null,
  },
};

export const useTgStateRaw = create<TgState>()((set) => ({
  ...defaultTgState,
  actions: {
    hydrate: (fresh: Partial<TgState>) => set(fresh),
    updateStartappArgs: (args: Partial<StartAppArgs>) =>
      set((prev) => ({
        startAppArgs: { ...prev.startAppArgs, ...args },
      })),

    updateBackButton: (args: Partial<StartAppArgs>) =>
      set((prev) => ({
        backButton: { ...prev.backButton, ...args },
      })),
  },
}));

export const useTgState = () =>
  useTgStateRaw(
    useShallow((state) => ({
      ...state,
    }))
  );

export const useTgActions = () => useTgStateRaw(useShallow((state) => state.actions));

export const useBackButtonProps = () =>
  useTgStateRaw(useShallow((state) => state.backButton));
export const useStartappArgs = () =>
  useTgStateRaw(useShallow((state) => state.startAppArgs));
